export enum TipoUsuario{
    /**
     * Persona Fisica - CIUDADANO
    */
    CIUDADANO = 1, 
    /**
     * Persona Fisica - ABOGADO
    */
    ABOGADO = 2, 
    /**
     * Persona Juridica - JURIDICA
    */
    JURIDICA = 3,
    /**
     * Persona Juridica - GUBERNAMENTAL
    */
    GUBERNAMENTAL = 4
}

/** Tipos de Usuario para el Perfil - Opciones */
export enum TipoUsuarioPerfilOpcionEnum{
    /**
     * Persona Fisica - Ciudadano
    */
    CIUDADANO = 1, 
    /**
     * Persona Juridica - Abogado | Paralegal | Administrador
    */
    ENTIDAD = 2
}
/** Tipos de consultas para los endpoint - datos casos por usuario */
export enum TipoConsultaUsuarioEnum {
    USUARIO = 1,
    ENTIDAD = 2,
    ABOGADO_PARALEGAL = 3
}